import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { headN } from '@cullylarson/f';
import Col100 from '@@client/components/Col100';
import Loading from '@@client/components/Loading';
import loadNewArrivals from '@@client/parts/inventory/loadNewArrivals';
import PartCardList from '@@client/parts/PartCardList';
export default connect(function (_ref) {
  var inventory = _ref.parts.inventory;
  return {
    newArrivalsStore: inventory.newArrivalsList
  };
}, function () {
  return {};
})(function (_ref2) {
  var newArrivalsStore = _ref2.newArrivalsStore;
  loadNewArrivals();
  if (newArrivalsStore.doing) return /*#__PURE__*/_jsx(Loading, {});
  if (!newArrivalsStore.total) return null;
  return /*#__PURE__*/_jsx(Col100, {
    children: /*#__PURE__*/_jsx(PartCardList, {
      headingBg: "blue",
      heading: "New Arrivals",
      parts: headN(6, newArrivalsStore.entities)
    })
  });
});